/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import api from '../api';
import { useAuth } from '../context/AuthContext';

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const { login } = useAuth();

    const handleLogin = async () => {
        try {
            const response = await api.post('/api/Auth/token', {
                userName: email,
                password
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.data?.token) {
                login(response.data.token);
                navigate('/customers');
            } else {
                console.error('Login failed:', response.data);
            }
        } catch (error) {
            console.error('Login failed:', "Wrong username or password");
        }
    };

    return (
        <div className="d-flex min-vh-100" style={{ fontFamily: `'Segoe UI', sans-serif` }}>
            {/* Left Panel */}
            <div
                className="d-none d-md-flex flex-column justify-content-center align-items-center text-white p-5"
                style={{
                    background: 'linear-gradient(135deg, #0a0e33 0%, #2d3a8c 100%)',
                    flex: 1,
                }}
            >
                <img src="/logo.png" alt="Logo" style={{ width: '140px', marginBottom: '30px' }} />
                <h1 className="fw-bold">Welcome Back</h1>
                <p className="text-light text-center" style={{ maxWidth: '300px' }}>
                    Sign in to access your dashboard, analytics, and more.
                </p>
            </div>

            {/* Right Panel */}
            <div className="d-flex flex-column justify-content-center align-items-center bg-light flex-grow-1">
                <div
                    className="p-4 shadow-lg"
                    style={{
                        width: '100%',
                        maxWidth: '420px',
                        background: 'rgba(255, 255, 255, 0.9)',
                        borderRadius: '20px',
                        backdropFilter: 'blur(10px)',
                    }}
                >
                    <h3 className="mb-4 text-center text-dark fw-semibold">Login to your account</h3>
                    <form onSubmit={e => { e.preventDefault(); handleLogin(); }}>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">Username</label>
                            <input
                                type="text"
                                id="email"
                                className="form-control"
                                placeholder="Enter your username"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-4">
                            <label htmlFor="password" className="form-label">Password</label>
                            <input
                                type="password"
                                id="password"
                                className="form-control"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        <div className="d-grid">
                            <button
                                className="btn btn-lg text-white"
                                style={{
                                    backgroundColor: '#0a0e33',
                                    transition: '0.3s',
                                }}
                                type="submit"
                            >
                                Login
                            </button>
                        </div>
                    </form>
                    {/* <div className="text-center text-muted mt-3" style={{ fontSize: '0.85rem' }}>
                        &copy; {new Date().getFullYear()} Your Company
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
